import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
import DropdownMenu from "../B2BMainNav/DropdownMenu.esm.js";
const SubnavDropdown = ({
  isOpen,
  renderLink,
  children
}) => {
  return /* @__PURE__ */ jsx(DropdownMenu, { isOpen, zIndex: "$zIndices.popover", left: 0, children: children.map((item) => /* @__PURE__ */ jsx(Box, { as: "li", sx: {
    padding: "$spacing.xs $spacing.sm",
    fontFamily: "$fonts.sansSerif",
    lineHeight: "$lineHeights.body",
    ":hover, :focus": {
      backgroundColor: "$colors.backgroundBlue"
    }
  }, children: renderLink(item) }, item.id)) });
};
export {
  SubnavDropdown as default
};
